import { useState } from 'react'

/** Transient UI state of a banner + thumbnail pair of image fields: which one is uploading and which image the preview dialog shows. */
export function useMediaUploadUi() {
  const [mediaPreviewUrl, setMediaPreviewUrl] = useState<string | null>(null)
  const [isBannerUploading, setIsBannerUploading] = useState(false)
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false)

  return {
    mediaPreviewUrl,
    setMediaPreviewUrl,
    isBannerUploading,
    setIsBannerUploading,
    isThumbnailUploading,
    setIsThumbnailUploading,
    isMediaUploading: isBannerUploading || isThumbnailUploading,
  }
}
